import { createStore as createVuexStore } from 'vuex';

import tabs from './tab';

export const createStore = (app) => {
    return createVuexStore({
        modules: {
            tabbar: tabs(app),
        },
        state() {
            return {
                tab: true,
                phone:[],
                webshop: {
                    languages: [
                        { code: "de", label: "Deutsch" },
                        { code: "en", label: "Englisch" },
                        { code: "fr", label: "Französisch" },
                        { code: "it", label: "Italienisch" },
                        { code: "pt", label: "Portugiesisch" }
                    ],
                },
                reminder: {
                    reminders: [],
                    next: [],
                },
                loading:{
                    callparty: false,
                },
                callparty: {
                  companies: [],
                  rescheduled:[],
                  dailyCalls: 0,
                  active: false,
                },
                notifications: {
                  counts: {
                      count: 0,
                      flaggingCount: 0,
                      releasesCount: 0,
                  },
                  notifications: {
                      flagging: [],
                      releases: [],
                      deletings: [],
                  },
                },
                status: {
                    stock: {
                        stockResidue: [],
                    },
                    orders:{},
                    sales: {}
                },
                mediakitLanguages: [],
                branches: [],
                attributes: [],
                users: [],
                online: [],
                userRoles: [],
                countries: [],
                languages: [],
                customerTypes: [],
                actionTypes: [],
                actionDeclinations: [],
                businessQuarter: {},
                businessYear: {},
                categories: {},
            }
        },
        mutations: {
            setTab(state, active){
                state.tab = active;
            },
            setConfig(state, config){
                state.users = config.users;
                state.userRoles = config.userRoles;
                state.countries = config.countries;
                state.attributes = config.attributes;
                state.languages = config.languages;
                state.branches = config.branches;
                state.customerTypes = config.customerTypes;
                state.actionTypes = config.actionTypes;
                state.actionDeclinations = config.actionDeclinations
                state.businessQuarter = config.businessQuarter;
                state.businessYear = config.businessYear;
                state.mediakitLanguages = config.mediakitLanguages;
                state.categories = config.categories;
            },
            setCallpartyLoading(state, status){
              state.loading.callparty = status;
            },
            setCallparty(state, callparty){
                state.callparty = callparty;
            },
            setStatus(state, status){
                state.status = status;
            },
            setNotifications(state, notifications){
                state.notifications = notifications;
            },
            setReminders(state, reminders){
                state.reminder = reminders;
            },
            setCalls(state, calls){
                state.phone = calls;
            },
            setUsers(state, users){
                state.users = users;
            },
            setBranches(state, branches){
                state.branches = branches;
            },
            setUsersOnline(state, users) {
                state.online = users;
            },
            setUserOnline(state, user) {
                if(!state.online.some((e, i, a) => {
                    return e.id == user.id;
                })){
                    state.online.push(user);
                }
            },
            setUserOffline(state, user) {
                let index = state.online.findIndex(element => {
                    return element.id == user.id;
                });

                if(index !== false){
                    state.online.splice(index, 1);
                }
            },
        }
    });
};